import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getOrganizationsRequest = (params) =>
  restRequest({ uri: 'organizations', method: HttpMethods.Get, ...params });
